import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { TOOLS } from "../lib/atomika-tools";
import { useOverview } from "../lib/atomika-overview";

export const Route = createFileRoute("/farsimi")({
  component: MobilePage,
});

function MobilePage() {
  const navigate = useNavigate();
  const overview = useOverview();
  const initials = overview?.user.initials ?? "";
  const kpi = (i: number) => overview?.kpis[i];
  return (
    <div className="flex flex-col items-center gap-[22px] px-5 pb-[70px] pt-10">
      <div className="max-w-[420px] text-center">
        <div className="text-[12.5px] font-bold uppercase tracking-[0.05em] text-brand">
          Farsímaútgáfa
        </div>
        <h1 className="m-0 mt-2 font-display text-2xl font-extrabold text-ink">
          Atomika stjórnborð í vasanum
        </h1>
      </div>

      <div className="h-[710px] w-[340px] flex-none rounded-[44px] bg-ink p-[11px] shadow-[0_30px_70px_rgba(11,36,71,.28)]">
        <div className="relative h-full w-full overflow-hidden rounded-[34px] bg-canvas">
          <div className="absolute left-1/2 top-0 z-[5] h-[26px] w-[130px] -translate-x-1/2 rounded-b-2xl bg-ink" />
          <div className="h-full overflow-auto">
            {/* phone topbar */}
            <div className="sticky top-0 z-[4] flex items-center gap-[9px] border-b border-line bg-white px-[18px] pb-3.5 pt-[34px]">
              <img
                src="/logo/atomika-horizontal.svg"
                className="h-[22px] w-auto"
                alt="Atomika"
              />
              <div className="flex-1" />
              <div className="flex h-[30px] w-[30px] items-center justify-center rounded-full bg-gradient-to-br from-brand to-brand-dark text-[11px] font-bold text-white">
                {initials}
              </div>
            </div>
            <div className="p-4">
              <div className="text-[11px] font-bold uppercase tracking-[0.05em] text-brand">
                Atomika stjórnborð
              </div>
              <h2 className="m-0 mb-[3px] mt-[5px] font-display text-[22px] font-extrabold text-ink">
                Góðan dag{overview ? `, ${overview.user.name}` : ""}
              </h2>
              <p className="m-0 mb-3.5 text-[12.5px] leading-[1.4] text-muted">
                Fjórar tengdar lausnir — eitt vistkerfi.
              </p>

              <div className="mb-4 grid grid-cols-2 gap-2.5">
                <div className="rounded-[14px] border border-line bg-white px-[13px] py-3">
                  <div className="text-[10.5px] font-semibold text-muted-2">
                    {kpi(0)?.label ?? "Virk hitakerfi"}
                  </div>
                  <div className="font-display text-[22px] font-extrabold text-ink">
                    {kpi(0)?.value ?? "—"}
                  </div>
                </div>
                <div className="rounded-[14px] border border-line bg-white px-[13px] py-3">
                  <div className="text-[10.5px] font-semibold text-muted-2">
                    {kpi(1)?.label ?? "Virk frávik"}
                  </div>
                  <div
                    className="font-display text-[22px] font-extrabold"
                    style={{ color: kpi(1)?.valueColor ?? "#E23B3B" }}
                  >
                    {kpi(1)?.value ?? "—"}
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-2.5">
                {TOOLS.map((t) => (
                  <Link
                    key={t.id}
                    to={t.route}
                    className="flex cursor-pointer items-center gap-3 rounded-[15px] border border-line bg-white px-3.5 py-[13px]"
                  >
                    <div
                      className="flex h-[42px] w-[42px] flex-none items-center justify-center rounded-xl font-display text-[18px] font-extrabold"
                      style={{ background: t.bg, color: t.color }}
                    >
                      {t.glyph}
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="font-display text-sm font-bold text-ink">
                        {t.name}
                      </div>
                      <div className="text-[11.5px] text-muted-2">{t.tag}</div>
                    </div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#B0BCCE"
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 6l6 6-6 6" />
                    </svg>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={() => navigate({ to: "/" })}
        className="h-11 cursor-pointer rounded-xl border border-line bg-white px-[22px] text-sm font-bold text-ink"
      >
        Aftur í skjáborðsútgáfu
      </button>
    </div>
  );
}
